import type { ThemeType } from 'components/shared/productList/shared/types';
import chanelTheme from './brands/chanelTheme';
import defaultTheme from './defaultTheme';
import { useJavascriptRequestDataModelQuery } from 'autogen/swagger/all/hooks';

export default function useThemeHandler() {
    const { data: state } = useJavascriptRequestDataModelQuery({ enabled: false });
    const theme = state?.javascriptPageContext?.brandContext as ThemeType;

    switch (theme) {
        case 'chanel':
            return chanelTheme;
        default:
            return defaultTheme;
    }
}
